import * as React from "react";
import styled from "styled-components";

import type { FlipData, FlipType } from ".";

interface FlipperProps {
  data: FlipData[];
  type: FlipType;
}

export const Flipper: React.FC<FlipperProps> = ({ data, type }) => {
  const [currentSlide, setCurrentSlide] = React.useState<number>(0);

  const handleAnimation = (dir: -1 | 1) => {
    setCurrentSlide((prev) => (prev + dir + data.length) % data.length);
  };

  return (
    <FlipContainer type={type}>
      <IndicatorLeft
        className="btn btn-light border"
        onClick={() => handleAnimation(-1)}
      >
        &#8249;
      </IndicatorLeft>
      {data.map(({ imgSrc, smallText, title, description }, idx) => (
        <FlipInner
          key={idx}
          className="bg-primary"
          active={currentSlide === idx}
        >
          <Contents className="">
            {imgSrc && <img src={imgSrc} alt="" width={120} height={120} />}
            {title && (
              <ContentTitle type={type}>
                {smallText && <span>{smallText}</span>}
                {title}
              </ContentTitle>
            )}
            {description && (
              <ContentDescription>{description}</ContentDescription>
            )}
          </Contents>
        </FlipInner>
      ))}
      <IndicatorRight
        className="btn btn-light border"
        onClick={() => handleAnimation(1)}
      >
        &#8250;
      </IndicatorRight>
    </FlipContainer>
  );
};

const FlipContainer = styled.div<{ type: FlipType }>`
  position: relative;
  width: ${(p) => (p.type === "benefits" ? "40vw" : "60vw")};
  height: ${(p) => (p.type === "benefits" ? "40vw" : "60vw")};
  max-width: ${(p) => (p.type === "benefits" ? "25rem" : "30rem")};
  max-height: ${(p) => (p.type === "benefits" ? "25rem" : "30rem")};
`;

const FlipInner = styled.div<{ active: boolean }>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  transition: 500ms all cubic-bezier(0.34, 1.56, 0.64, 1);
  z-index: ${(p) => (p.active ? 1 : 0)};
  transform-style: preserve-3d;
  transform: ${(p) => (p.active ? "rotateY(0deg)" : "rotateY(180deg)")};
`;

const IndicatorLeft = styled.button`
  position: absolute;
  padding: 0 0 0.25rem 0;
  width: 2rem;
  height: 2rem;
  top: calc(50% - 1rem);
  left: -1rem;
  z-index: 1;
  font-size: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 150ms all cubic-bezier(0.34, 1.15, 0.85, 1);
  opacity: 0.9;
  z-index: 2;
  &:active {
    font-size: 3rem;
    padding: 0 0 0.5rem 0;
  }
`;

const IndicatorRight = styled(IndicatorLeft)`
  left: calc(100% - 1rem);
`;

const Contents = styled.div`
  padding: 1rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
`;

const ContentTitle = styled.h5<{ type: FlipType }>`
  font-size: ${(p) => (p.type === "benefits" ? "4em" : "2em")};

  span {
    display: block;
    font-size: 0.2em;
  }
`;

const ContentDescription = styled.p`
  font-size: 1.25em;
`;
